var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"empty"},[(_vm.type === 'pie-chart')?[_c('img',{attrs:{"src":_vm.getImage('empty/empty-pie-chart.svg'),"alt":"Chart"}}),_c('p',[_vm._v("No data")])]:(_vm.type === 'line-chart')?[_c('img',{staticClass:"line",attrs:{"src":_vm.getImage('empty/empty-line-chart.svg'),"alt":"Chart"}}),_c('p',[_vm._v("No data")])]:_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }